import { useRef, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Upload, Check, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function FileUpload({ label, accept, value, onChange, testid }) {
  const ref = useRef();
  const [busy, setBusy] = useState(false);

  const handle = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.path);
      toast.success("Dosya yüklendi");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Yükleme başarısız");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <button
        type="button"
        onClick={() => ref.current?.click()}
        data-testid={testid}
        className={`w-full border border-dashed rounded-xl p-6 flex items-center gap-4 transition-colors ${
          value ? "border-[color:var(--verified)] bg-[color:var(--verified)]/5" : "border-neutral-300 hover:border-neutral-500 bg-neutral-50"
        }`}
      >
        <div className="h-11 w-11 rounded-full bg-white border border-neutral-200 grid place-items-center">
          {busy ? <Loader2 size={18} className="animate-spin" /> : value ? <Check size={18} className="text-[color:var(--verified)]" /> : <Upload size={18} />}
        </div>
        <div className="text-left">
          <div className="font-medium text-sm">{label}</div>
          <div className="text-xs text-neutral-500 mt-0.5">
            {value ? "Yüklendi — değiştirmek için tekrar tıkla" : "Bir dosya seçmek için tıkla (JPG, PNG, PDF — max 10MB)"}
          </div>
        </div>
      </button>
      <input ref={ref} type="file" accept={accept} onChange={handle} className="hidden" />
    </div>
  );
}
